import React, {useEffect} from 'react';
import styles from "../../../styles/editAnnoucement.module.scss";
import {
    FloatingLabelDatePicker,
    FloatingLabelInput,
    FloatingLabelSelect
} from "../../elements/floatingLabelInput/FloatingLabelInput";
import dayjs from "dayjs";
import {
    APP_OPEN_PAGE_OPTION,
    DISPLAY_FREQUENCY_OPTIONS,
    DISPLAY_PAGE_OPTIONS,
    EVERY_TIME_FREQUENCY,
    TARGET_USER_GROUP_OPTIONS,
    syncDisplayInPageWithFrequency,
} from "../../../utils/announcement.util";

const AddAnnoucementStep2 = ({ formData, updateFormData }) => {
    const isAppOpen = formData.displayFrequency === EVERY_TIME_FREQUENCY;

    useEffect(() => {
        syncDisplayInPageWithFrequency(formData, updateFormData);
    }, [formData.displayFrequency]);

    return (
        <div>
            <section className={styles.section}>
                <h3 className={styles.sectionTitle}>Prikaz u aplikaciji</h3>
                <div className={styles.formRowDouble}>
                    <FloatingLabelSelect
                        label="Izbor stranice u aplikaciji"
                        value={formData.displayInPage}  // Just pass the string value
                        onChange={(value) => updateFormData('displayInPage', value)}
                        items={isAppOpen ? [APP_OPEN_PAGE_OPTION] : DISPLAY_PAGE_OPTIONS}
                        disabled={isAppOpen}
                        placeholder="Izaberi stranicu"
                    />
                </div>
            </section>

            {/* Učestalost prikazivanja */}
            <section className={styles.section}>
                <h3 className={styles.sectionTitle}>Učestalost prikazivanja</h3>
                <div className={styles.formRowTriple}>
                    <FloatingLabelDatePicker
                        label="Start date"
                        value={formData.startDate ? dayjs(formData.startDate) : null}
                        onChange={(date) => updateFormData('startDate', date ? date.toISOString() : null)}
                        format="DD.MM.YYYY."
                        placeholder="29.01.2026."
                    />
                    <FloatingLabelDatePicker
                        label="End date"
                        value={formData.endDate ? dayjs(formData.endDate) : null}
                        onChange={(date) => updateFormData('endDate', date ? date.toISOString() : null)}
                        format="DD.MM.YYYY."
                        placeholder="29.01.2026."
                    />
                    <FloatingLabelSelect
                        label="Frekvencija prikaza"
                        value={formData.displayFrequency}
                        onChange={(value) => updateFormData('displayFrequency', value)}
                        items={DISPLAY_FREQUENCY_OPTIONS}
                        placeholder="Izaberite frekvenciju prikaza"
                    />
                </div>
            </section>

            {/* Targeting korisnika */}
            <section className={styles.section}>
                <h3 className={styles.sectionTitle}>Targeting korisnika</h3>
                <div className={styles.formRowTriple}>
                    <FloatingLabelSelect
                        label="Grupa korisnika"
                        value={formData.targetUserGroup}
                        onChange={(value) => updateFormData('targetUserGroup', value)}
                        items={TARGET_USER_GROUP_OPTIONS}
                        placeholder="Izaberite grupu korisnika"
                    />
                </div>
            </section>
        </div>
    );
};

export default AddAnnoucementStep2;